import type { Tick } from '@/utils/ticks'
import { TICKS_LIMIT } from '@/utils/consts'
import { useAutoRefresh } from './useAutorefresh'
import type { Ref } from 'vue'

interface TickPusherOptions {
  interval?: number
  limit?: number
}

export const useEyeTickPusher = (
  price: Ref<number | null>,
  ticks: Ref<Tick[]>,
  options?: TickPusherOptions,
) => {
  const limit = options?.limit ?? TICKS_LIMIT
  const interval = options?.interval ?? 500

  const push = () => {
    const value = price.value ?? ticks.value[ticks.value.length - 1]?.[1] ?? null
    if (value == null) {
      return false
    }
    const ts = Math.round(Date.now() / 1000)
    ticks.value.push([ts, value])
    ticks.value = ticks.value.slice(-limit)
    return true
  }

  const refresher = useAutoRefresh(() => { push() }, interval)

  return {
    push,
    refresher,
  }
}
